module.exports = __webpack_public_path__ + "img/Profile.436742d0.svg";